/**
 * lld-header-banner-price.js
 * Resynchronise la mensualité de la LIGNE PRIX du bandeau vert (fiche produit mobile) au
 * changement de variante. Chargé uniquement quand cette ligne est rendue (cf. le snippet).
 * Le prix INITIAL est rendu côté serveur (metafield lld.mensualite_36_mois) : ce script ne fait
 * que RE-SYNCHRONISER (pas de premier paint dépendant du JS = zéro flash/CLS).
 *
 * Depuis 2026-07-31 le bandeau peut afficher un COMPTEUR VISITEURS à la place, la ligne prix
 * devenant son repli masqué. Conséquences ici :
 *  - on ne masque plus le bandeau entier quand la mensualité disparaît (ça emporterait le
 *    compteur), on masque la LIGNE ;
 *  - on ne révèle jamais la ligne quand elle est le repli du compteur (c'est le script pré-paint
 *    du compteur qui en décide, il tourne avant celui-ci) ;
 *  - si plus rien n'est visible, on masque le bandeau ET on annule sa réserve de hauteur
 *    (classe no-lld-price-banner, cf. sections/header.liquid) — sinon 31px de blanc au-dessus de
 *    la galerie. Ce script est `defer` : ce cas-là est un shift après paint, acceptable car il
 *    n'arrive qu'au changement de variante (interaction) ou sur une divergence
 *    metafield / GreenLeaze au load (cf. anti-pattern n°13), pas sur le chemin normal.
 *
 * Mensualité = window.getAllPricesForProduct(prixHT)[36].monthly (miroir product-price-louer-from.js).
 * getAllPricesForProduct attend un prix HT → TTC / 1.2 si la variante est taxable.
 * Resync : 'variant:change' (taille) + 'greenleazePriceActualize' (script GreenLeaze async prêt).
 */
(function () {
  'use strict';
  var banner = document.querySelector('.lld-header-banner--price');
  if (!banner) return;
  var priceEl = banner.querySelector('.lld-header-banner-price__cta');
  if (!priceEl) return;
  var valueEl = priceEl.querySelector('[data-lld-header-monthly]');
  if (!valueEl) return;

  var counterEl = banner.querySelector('[data-visitor-mode]');
  // État posé par le script pré-paint du compteur : compteur visible = la ligne prix est son
  // repli masqué, et ce script n'a pas à la révéler.
  var priceIsFallback = !!(counterEl && !counterEl.hidden);

  var state = {
    priceTTC: parseInt(banner.dataset.price, 10),
    taxable: banner.dataset.taxable === 'true',
  };

  function fmt(v) {
    return Math.round(v).toLocaleString('fr-FR');
  }
  function priceHT() {
    if (isNaN(state.priceTTC)) return null;
    var taxRate = state.taxable ? 1.2 : 1;
    return state.priceTTC / taxRate / 100;
  }
  function syncBannerVisibility() {
    var counterVisible = !!(counterEl && !counterEl.hidden);
    var isEmpty = !counterVisible && priceEl.hidden;
    banner.hidden = isEmpty;
    document.documentElement.classList.toggle('no-lld-price-banner', isEmpty);
  }

  // Mensualité À AFFICHER : passe par getDisplayPriceForProduct, qui applique le MÊME
  // plancher d'apport que la modale de location (20 % du prix sur les vélos en TVA sur
  // marge) et amortit le supplément par les règles Greenleaze. Sans lui, ce montant repart
  // sur l'apport Greenleaze par défaut et annonce une mensualité PLUS ÉLEVÉE que la modale
  // (Cervélo 3 999 € : 131 € ici, 121,33 € dans la modale — mesuré le 22/09/2026).
  // `marginVat` = variante NON taxable, soit exactement le booléen qui pilote priceHT().
  // Repli sur getAllPricesForProduct si le CDN sert un greenleaze-script.js antérieur à cet
  // ajout : ancien montant (divergent), jamais de montant vide.
  function monthlyForDisplay(ht) {
    var displayed = isNaN(state.priceTTC) ? 0 : state.priceTTC / 100;
    if (typeof window.getDisplayPriceForProduct === 'function') {
      return window.getDisplayPriceForProduct(ht, 36, displayed, !state.taxable).monthly;
    }
    var prices = window.getAllPricesForProduct(ht) || {};
    return prices[36] && prices[36].monthly;
  }

  function update() {
    if (typeof window.getAllPricesForProduct !== 'function') return;
    var ht = priceHT();
    if (!ht) return;
    var m = monthlyForDisplay(ht);
    if (m) {
      valueEl.textContent = fmt(m);
      priceEl.hidden = priceIsFallback;
    } else {
      priceEl.hidden = true;
    }
    syncBannerVisibility();
  }

  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || !v.price) return;
    state.priceTTC = parseInt(v.price, 10);
    banner.dataset.price = v.price;
    update();
  });

  window.addEventListener('greenleazePriceActualize', update);
  // Ce script est `defer`, GreenLeaze est async : quand GreenLeaze gagne la course,
  // 'greenleazePriceActualize' est déjà passé et n'est JAMAIS rejoué → le bandeau
  // restait figé sur le metafield (mesuré 2026-07-30 en headless : 30 € affiché alors
  // que getAllPricesForProduct renvoyait 24 €). Sans cet appel, la ligne « Financer »
  // du bloc sticky (qui, elle, se resynchronise à froid) afficherait un prix différent
  // de ce bandeau — la divergence signalée, juste inversée.
  update();

  // Toute la ligne prix est cliquable = même action que le bouton « Louer » : ouvre la modale
  // location GreenLeaze. On proxifie le clic du déclencheur .greenleaze-button-product
  // (comportement identique garanti, aucun effet de bord visuel vs ajouter la classe au CTA).
  // Fallback si le JS GreenLeaze n'a pas rendu de bouton : navigation native vers l'ancre
  // financement (href). Le compteur visiteurs, lui, n'est pas cliquable.
  priceEl.addEventListener('click', function (e) {
    var trigger = document.querySelector('.greenleaze-button-product');
    if (trigger) {
      e.preventDefault();
      trigger.click();
      return;
    }
    // Repli historique = navigation vers #product-financing-options. Cette ancre n'est
    // plus rendue depuis que le bloc financement est masqué par défaut (2026-07-29) :
    // la laisser suivre son href n'écrit qu'une ancre morte dans l'URL. On neutralise
    // le clic dans ce cas seulement — si le bloc est réaffiché par le réglage, le repli
    // natif refonctionne tel quel.
    if (!document.querySelector('#product-financing-options')) e.preventDefault();
  });
})();
